export default "__VITE_ASSET__BvAoefox__"